<template>
  <div class="year-static" ref="yearStatic">
    <section ref="staticSection" class="static-section">
      <div>
        <header>
          <img class="report-logo" src="../../assets/images/year-review/review-logo@2x.png" />
        </header>
        <div class="static-summery">
          <!-- <p>In 2019,</p> -->
          <p>
            <b class="blue">2,111,324</b> truckers have driven with us, contributing
            <b class="blue">23,648,159</b> POI data updates for our community.
          </p>
        </div>
        <div class="static-truck" >
          <div class="left-plan" ref="leftPlan"></div>
          <div class="right-plan" ref="rightPlan"></div>
        </div>
        <div class="stop-brands part3bg">
          <div class="static-brand">
            <div class="brand-info">
              <p slot="brand-title">Top 3 Most Visited</p>
              <p slot="brand-title">Truck Stop Brands</p>
            </div>
            <div class="brand-imgs" slot="brand-img">
              <img class="imgs-item" v-for="item in brandImgs" :key="item" :src="require(`@/assets/images/year-review/static-brand${item}@2x.png`)" alt/>
            </div>
            <div class="line"><p></p></div>
          </div>
        </div>
        <div class="parking-spots" ref="parkingSpotsDom">
          <div class="static-brand stops-move-content" ref="parkingStopsCont">
            <div class="brand-info">
              <p slot="brand-title">3 States with Most</p>
              <p slot="brand-title">Truck Parking Spots</p>
            </div>
             <div class="brand-imgs" slot="brand-img">
              <img
                class="imgs-item"
                v-for="item in brandImgs"
                :key="item"
                :src="require(`@/assets/images/year-review/static-texas${item}@2x.png`)"
                alt
              />
            </div>
            <div class="line"><p></p></div>
          </div>
        </div>
        <div class="weight-stations" ref="weightStationsDom">
          <div class="static-brand weight-move-content" ref="weightStationsCont">
            <div class="brand-info">
              <p slot="brand-title">3 States with Most</p>
              <p slot="brand-title">Weigh Stations</p>
            </div>
             <div class="brand-imgs brand-imgs-only" slot="brand-img">
              <img class="imgs-only" src="@/assets/images/year-review/static-map@2x.png" alt />
            </div>
            <div class="line"><p></p></div>
          </div>
        </div>
        <div class="pic-two" ref="picTwoDom">
          <div class="static-brand pic-two-content" ref="picTwoCont">
           <div class="brand-imgs brand-imgs-two" slot="brand-img">
              <img
                class="imgs-two"
                v-for="item in brandImgs.slice(0,2)"
                :key="item"
                :src="require(`@/assets/images/year-review/static-job${item}@2x.png`)"
                alt
              />
            </div>
            <div class="line"><p></p></div>
          </div>
        </div>
        <div class="static-end">
          <p
            class="static-end-text"
          >Thank you for driving with us in 2019 and wish you safe travels into the new year!</p>
          <p class="static-end-truck" ref="wheelDom">
            <img
              src="@/assets/images/year-review/static-move-truck@2x.png"
              class="static-end-truck-img"
              alt
            />
          </p>
        </div>
        <div class="static-empty"></div>
      </div>
    </section>
  </div>
</template>
<script>
import BScroll from 'better-scroll'
export default {
  name: "year-static",
  props: ['showRotateTips','swiper'],
  data() {
    return {
      brandImgs: [1, 2, 3],
      startY: 0,
      scroll: null,
      onlyStatic: false,
      wow: null,
    };
  },
  mounted() {
    let that = this
    window.addEventListener("scroll",that.ani, true);
    this.$nextTick(()=>{
      this.scroll = new BScroll(this.$refs.yearStatic,{
        scrollY : true,
        pullDownRefresh: true
      })
      this.scroll.on('pullingDown',()=>{
        // console.log('pllllllll')
        that.swiper.params.noSwiping = false
        that.swiper.slidePrev();
        that.scroll.finishPullDown()
        
      })
      this.scroll.on('scroll',(e)=>{
        that.ani()
      })
    })
  },
  destroyed(){
    let that = this
    window.removeEventListener("scroll",that.ani, true);
  },
  methods: {
    debounce(fn, wait) {    
      var timeout = null;    
      return function() {        
        if(timeout !== null)   clearTimeout(timeout);        
        timeout = setTimeout(fn, wait);    
      }
    },
    ani() {
      if(!this.showRotateTips){
        this.isInView(this.$refs.picTwoDom,this.$refs.picTwoCont)
        this.isInView(this.$refs.wheelDom,this.$refs.wheelDom,"wheel")
        this.isInView(this.$refs.leftPlan,this.$refs.leftPlan,"leftPlan")
        this.isInView(this.$refs.rightPlan,this.$refs.rightPlan,"rightPlan")
        this.isInView(this.$refs.parkingSpotsDom,this.$refs.parkingStopsCont)
        this.isInView(this.$refs.weightStationsDom,this.$refs.weightStationsCont)
      }
    },
    isInView(ele,content,type){
      var obj = this.GetRect(ele)
      var divH = ele.offsetHeight
      let windowH =  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      if (obj.top >= windowH) { // 在视口之下
        if(type === 'wheel'){
          content.classList.remove("move-static-end-truck")
        }else if(type === 'leftPlan'){
          content.classList.remove("show-left-plan")
        }else if(type === 'rightPlan'){
          content.classList.remove("show-right-plan") 
        }else{
          content.classList.remove("move-parking-spots") 
        }
      }
      if (obj.top < windowH && obj.bottom >= windowH) { // 正在出现
        //
      }
      if (obj.top > 0 && obj.top <  windowH && obj.bottom > 0 && obj.bottom <  windowH) { // 正在视口中
        if(type === 'wheel'){
          content.classList.add("move-static-end-truck")
        }else if(type === 'leftPlan'){
          content.classList.add("show-left-plan")
        }else if(type === 'rightPlan'){
          content.classList.add("show-right-plan") 
        }else{
          content.classList.add("move-parking-spots") 
        }
      }
      if (obj.top <= 0 && obj.bottom <= divH && obj.bottom > 0) { // 正在离开视口
        //
      }
      if (obj.bottom <= 0) { // 已经离开视口
        if(type === 'wheel'){
          content.classList.remove("move-static-end-truck")
        }else if(type === 'leftPlan'){
          content.classList.remove("show-left-plan")
        }else if(type === 'rightPlan'){
          content.classList.remove("show-right-plan") 
        }else{
          content.classList.remove("move-parking-spots") 
        }
      }
    },
    GetRect (element) {
      var rect = element.getBoundingClientRect() // 距离视窗的距离
      var top = document.documentElement.clientTop ? document.documentElement.clientTop : 0 // html元素对象的上边框的宽度
      var left = document.documentElement.clientLeft ? document.documentElement.clientLeft : 0
      return {
        top: rect.top - top,
        bottom: rect.bottom - top,
        left: rect.left - left,
        right: rect.right - left
      }
    },
  },
  // watch: {
  //   showPlanAnim: {
  //     handler(newVal, old) {
  //       if(newVal === 'S'){
  //         document.querySelector('.left-plan').className = 'left-plan show-left-plan-slow';
  //         document.querySelector('.right-plan').className = 'right-plan show-right-plan-slow';
  //       }else if (newVal === 'T') {
  //         document.querySelector('.left-plan').className = 'left-plan show-left-plan';
  //         document.querySelector('.right-plan').className = 'right-plan show-right-plan';
  //       }
  //     },
  //     immediate : true
  //   }
  // }
};
</script>
<style lang="scss" scoped>
@import "@/scss/rem.scss";
$blue: rgb(3, 118, 239);
.padding25 {
  padding: 0 rem(25px);
  box-sizing: border-box;
}
.year-static {
  width: 100%;
  height: 100%;
  overflow: hidden;
  // overflow-y:scroll;
  // overflow-x:hidden;
  box-sizing: border-box;
  padding-bottom: rem(75px);
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index: 9999;
  header {
    display: flex;
    align-items: center;
    width: 100%;
    height: rem(44px);
    @extend .padding25;
  }
  .report-logo {
    height: rem(18px);
  }
  > section {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    // padding-bottom: rem(30px);
    .blue {
      color: $blue;
    }
    .static-summery {
      font-family: Gotham-Bold;
      font-size: rem(18px);
      @extend .padding25;
      // > p:first-child {
      //   font-family: Gotham-Book;
      //   font-size: rem(16px);
      //   margin-bottom: rem(11px);
      //   @extend .blue;
      // }
      p {
        line-height: rem(27.5px);
      }
      b {
        font-weight: normal;
      }
    }
    .static-brand{
      overflow: hidden;
      .brand-info{
        color: rgb(3,118,239);
        padding: 0 rem(25px);
        box-sizing: border-box;
        >p:first-child{
          font-family: Gotham-Medium;
          font-size: rem(18px);
        }
        >p:last-child{
          padding-bottom: rem(35px);
          font-family: Gotham-Bold;
          font-size: rem(27.5px)
        }
      }
      .line{
        padding: 0 rem(30px);
        >p{
          padding: 0;
          height: 1px;
          width: 100%;
          background-color: #0030621a;
          margin-top: rem(30px);
        }
        // &:before{
        //   content: '';
        //   display: block;
        //   // border-bottom: 1px solid #0030621a;
        //   border-bottom: 1px solid #003062;
        //   margin-top: rem(35px) ;
        // }
      }
    }
    .static-truck {
      width: 100%;
      height: rem(284.5px);
      background: url("../../assets/images/year-review/static-truck@2x.png")
        no-repeat center;
      background-size: 100%;
      position: relative;
      @extend .padding25;
      .left-plan {
        width: rem(68.5px);
        height: rem(46px);
        background: url("../../assets/images/year-review/left-plane.png")
          no-repeat center;
        background-size: 100%;
        position: absolute;
        // top:rem(69.5px);
        top: rem(104.5px);
        // top:rem(34.5px);
        left: rem(25px);
        opacity: 1;
      }
      .show-left-plan {
        animation: moveLeftPlan 300ms linear;
        animation-fill-mode:forwards;
      }
      .show-left-plan-slow {
        animation: moveLeftPlan 3s linear;
        animation-fill-mode:forwards;
      }
      .right-plan {
        width: rem(24.5px);
        height: rem(43.5px);
        background-color: pink;
        background: url("../../assets/images/year-review/right-plan.png")
          no-repeat center;
        background-size: 100%;
        position: absolute;
        top: rem(128.5px);
        // top:rem(93.5px);
        // top:rem(93.5px);
        right: rem(25px);
        opacity: 1;
        // animation:moveRightPlan 3s linear;
      }
      .show-right-plan {
        animation: moveRightPlan 300ms linear;
        animation-fill-mode:forwards;
      }
      .show-right-plan-slow {
        animation: moveRightPlan 2s linear;
        animation-fill-mode:forwards;
      }
    }
    .brand-imgs {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      @extend .padding25;
      // padding
      .imgs-item {
        width: 33.3%;
      }
      .imgs-only {
        width: 100%;
        // height: rem(325px);
      }
      .imgs-two {
        width: 50%;
      }
    }
    .brand-imgs.brand-imgs-only {
      padding: 0;
    }
    .brand-imgs.brand-imgs-two {
      @extend .padding25;
    }
    .static-end {
      display: flex;
      flex-direction: column;
      height: rem(182px);
      width: 100%;
      background: url("../../assets/images/year-review/static-truckBg@2x.png")
        no-repeat center;
      background-size: cover;
      // margin-top: rem(-44px);
    }
    .static-end-truck {
      position: relative;
      flex: 1;
      margin-bottom: rem(20px);
      > img {
        position: absolute;
        height: rem(90px);
        bottom: rem(-40px);
        left: 50%;
        // transform: translate(-50%,-50%);
        transform: translate(90%, -50%);
      }
    }
    .move-static-end-truck {
      > img {
        animation: moveTruck 2s linear;
        animation-fill-mode:forwards;
      }
    }
    .static-empty{
      width: 100%;
      height: rem(76px);
    }
    .parking-spots,
    .weight-stations,
    .pic-two {
      opacity: 1;
      position: relative;
      margin-bottom: rem(25px);
      // margin-top: rem(0px);
    }
    .parking-spots{
      height: rem(280px);
    }
    .weight-stations{
      height: rem(470px);
    }
    .pic-two{
      height:rem(200px);
    }
    .stops-move-content,.weight-move-content,.pic-two-content{
      position: absolute;
      top: rem(35px); 
      left: 0;
    } 
    // {
    //   position: absolute;
    //   top: rem(10px); 
    //   left: 0;
    // } 
    .move-parking-spots {
      animation: moveParkingSpots 300ms linear;
      animation-fill-mode:forwards;
      // transition: top 300ms linear;
    }
    .static-end-text {
      width: 100%;
      font-family: Gotham-Book;
      font-size: rem(13px);
      color: rgb(119, 125, 158);
      @extend .padding25;
    }
    .static-share {
      height: rem(100px);
      @extend .padding25;
      box-shadow: rem(2px) rem(2px) rem(2px) $blue;
    }

    .report-share {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: rem(43px);
      color: #ffffff;
      font-family: Gotham-Book;
      font-size: rem(16px);
      border-radius: rem(2px);
      background: $blue;
    }
  }
}
.part3bg{
  padding-top: rem(30px);
  background: #f6fbfe url(../../assets/images/year-review/part3bg.png) no-repeat top left;
  background-size: 100% 90%;
  margin-bottom: rem(25px);
  
}

@keyframes moveTruck {
  0% {
    transform: translate(90%, -50%);
  }
  50% {
    transform: translate(0%, -50%);
  }
  100% {
    transform: translate(-50%, -50%);
  }
}
@keyframes moveLeftPlan {
  0% {
    // opacity: 0.4;
    top: rem(104.5px);
  }
  100% {
    // opacity: 1;
    top: rem(69.5px);
  }
}

@keyframes moveRightPlan {
  0% {
    // opacity: 0.4;
    top: rem(128.5px);
  }
  100% {
    // opacity: 1;
    top: rem(93.5px);
  }
}

@keyframes moveParkingSpots {
  0% {
    // opacity: 0.4;
    top: rem(35px);
  }
  100% {
    // opacity: 1;
    top: rem(0px);
  }
}
</style>
